import React from 'react';

import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';

import { IExercise } from '../../../../types/interfaces/exercise';
import AppEntityAvatar, {
  AppEntityAvatarProps,
} from '../app-entity-avatar/AppEntityAvatar';

interface AppExerciseEntityAvatarProps extends AppEntityAvatarProps {
  exercise?: IExercise;
}

export default function AppExerciseAvatar(props: AppExerciseEntityAvatarProps) {
  const { exercise, ...avatarProps } = props;

  return (
    <AppEntityAvatar
      {...avatarProps}
      fallbackSeedId={exercise?.id}
      fallbackSeedName={exercise?.title}
      directPreviewStorageLink={exercise?.avatar?.directPreviewStorageLink}
      directStorageLink={exercise?.avatar?.directStorageLink}
      previewStorageLink={exercise?.avatar?.previewStorageLink}
      storageLink={exercise?.avatar?.storageLink}>
      <FitnessCenterIcon />
    </AppEntityAvatar>
  );
}
